var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgModeledFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.674 2.667c0-.734.593-1.334 1.326-1.334h5.334l4 4v8c0 .734-.6 1.334-1.334 1.334H3.994c-.734 0-1.327-.6-1.327-1.334l.007-10.666zm5.993-.334V6h3.667L8.667 2.333zM11 7.5v2.444H8.725v-.916h-.65v2.444h.65v-.916H11V13H8.725v-.917h-1.3V9.028h-.65v.916H4.5V7.5h2.275v.917h1.95V7.5H11z"
})));
export default SvgModeledFile;